/// <amd-module name="UserFeedbackTool" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>
/// <reference path="../../../typings/typeahead/uitk.d.ts" />

import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";
import {SearchType, UserFeedbackDataLogger} from "typeahead/core/userfeedbacktool/data/UserFeedbackDataLogger";
import {AppreciationMessage} from "typeahead/core/userfeedbacktool/ui/AppreciationMessage";
import {DynamicFooter} from "typeahead/core/userfeedbacktool/ui/DynamicFooter";
import {UserFeedbackBox} from "typeahead/core/userfeedbacktool/ui/UserFeedbackBox";

const footerHtml: string = `
<div style="position:absolute; bottom:24px;" class="feedbackFooter">
 <button type="button" class="userfeedback cancel">CANCEL</button>
 <button type="button" class="userfeedback submit" disabled="disabled">SUBMIT</button>
</div>
`;

export class UserFeedbackTool {

    public static getSingleton() {
        if (!this.instance) {
            this.instance = new UserFeedbackTool();
        }
        return this.instance;
    }
    private static instance: UserFeedbackTool;

    private static setButtonText($footerHtml: JQuery): void {
        $footerHtml.find("button.submit").text(loc.submitMessage);
        $footerHtml.find("button.cancel").text(loc.cancelMessage);
    }

    private static setInputHasFocus(domElementId: string): void {
        if (domElementId) {
            $("#" + domElementId).attr("data-hasfocus", "true");
        }
    }

    private $userFeedbackToolModal: JQuery;

    private constructor() {}

    public render(searchType: SearchType, searchQuery: string, lob: string, tnls: string, domElementId?: string):
        void {
        const $footerHtml: JQuery = $(footerHtml);
        const $contentDiv: JQuery = $(document.createElement("div"));
        $contentDiv.attr("aria-modal", "true");
        $contentDiv.append(new UserFeedbackBox().getJQueryElement());
        UserFeedbackTool.setButtonText($footerHtml);
        $contentDiv.append($footerHtml);

        const userFeedbackToolModal: IUitkModal = uitk.modal.create({
            animation: "fade-in-none-out",
            content: $contentDiv,
            focusOpen: "rd1",
            footer: false,
            modalId: "userFeedbackToolModal",
        });
        this.$userFeedbackToolModal = $("#userFeedbackToolModal");

        this.modifyStyle();
        this.setPosition();
        this.addButtonClickEventHandlers(userFeedbackToolModal, searchType, searchQuery, lob, tnls, domElementId);
        this.enableSubmitButton();
    }

    private enableSubmitButton(): void {
        this.$userFeedbackToolModal.find("input[name=issue]").change(() => {
            this.$userFeedbackToolModal.find("button.submit").removeAttr("disabled");
        });
    }

    private setPosition(): void {
        if (!TypeaheadUtils.isWithinMobileBreakpoint()) {
            const $dropdown: JQuery = $(".autocomplete-dropdown:visible");
            if ($dropdown.length) {
                if ($dropdown.offset().top  > $(window).scrollTop() + 68) {
                    this.$userFeedbackToolModal.find(".modal-inner").css("margin-top",
                        $dropdown.offset().top - $(window).scrollTop() - 150);
                }
                this.$userFeedbackToolModal.find(".modal-inner").css("margin-left", $dropdown.offset().left + 5);
            }
        }
    }
    private modifyStyle(): void {
        this.$userFeedbackToolModal.children(".modal-inner").addClass("userFeedbackContainer");
        $(".otherField").hide();
        this.buttonDisplayFeatures();
    }

    private buttonDisplayFeatures() {
        this.buttonDisplayOtherBox("#rd4", true);
        this.buttonDisplayOtherBox("#rd3", false);
        this.buttonDisplayOtherBox("#rd2", false);
        this.buttonDisplayOtherBox("#rd1", false);
    }

    private buttonDisplayOtherBox(id: string, shouldShow: boolean): void {
        $(id).on("click change", () => {
            if ($(id).prop("checked")) {
                if (shouldShow) {
                    $(".otherField").show().focus();
                } else {
                    $(".otherField").hide();
                }
            }
        });
    }

    private addButtonClickEventHandlers(userFeedbackToolModal: IUitkModal, searchType: SearchType, searchQuery: string,
                                        lob: string, tnls: string, domElementId: string): void {
        this.$userFeedbackToolModal.find("button.submit").disabled = true;
        this.$userFeedbackToolModal.find("button.cancel").on("click", () => {
            UserFeedbackTool.setInputHasFocus(domElementId);
            userFeedbackToolModal.close();
        });
        this.$userFeedbackToolModal.find("button.submit").on("click", () => {
            this.handleSubmit(userFeedbackToolModal, searchType, searchQuery, lob, tnls, domElementId);
        });
    }

    private handleSubmit(userFeedbackToolModal: IUitkModal, searchType: SearchType, searchQuery: string,
                         lob: string, tnls: string, domElementId: string): void {
        UserFeedbackTool.setInputHasFocus(domElementId);
        this.submitFeedbackData(lob, searchQuery, searchType, tnls);
        userFeedbackToolModal.close();
        AppreciationMessage.getSingleton().render(domElementId);
        $(".autocomplete-dropdown span.dynamicTextFooter").html("").prepend(new DynamicFooter().getJQueryForYes());
    }

    private submitFeedbackData(lob, searchQuery, searchType, tnls): void {
        const issueType: string = this.$userFeedbackToolModal.find("input[name='issue']:checked.user_feedback").val();
        let issueTypeOther: string;
        if (issueType === "other") {
            issueTypeOther = this.$userFeedbackToolModal.find(".field.otherField").val();
        }
        const expectedDestinationTypes: string[] = [];
        this.$userFeedbackToolModal.find("input[name='destination']:checked.user_feedback").each((index, element) => {
            expectedDestinationTypes.push($(element).val());
        });
        const comment = this.$userFeedbackToolModal.find(".field.comment").val();

        UserFeedbackDataLogger.getSingleton().log({
            areSuggestionsHelpful: false,
            comment,
            expectedDestinationTypes,
            issueType,
            issueTypeOther,
            lob,
            searchQuery,
            searchType,
            tnls,
        }, true);
    }
}
